module.exports = __webpack_public_path__ + "img/xsd.d267753b.png";